<div class="last-played-container">
    <app-dynamic-category *ngIf="games.length !==0" categoryName="{{categoryName}}" [linkUrl]="linkUrl" [games]="games">
    </app-dynamic-category>
</div>